import { render, staticRenderFns } from "./TerritoryViewer.vue?vue&type=template&id=4867c6b3"
import script from "./TerritoryViewer.vue?vue&type=script&lang=ts"
export * from "./TerritoryViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports